import { useEffect } from "react";
import { Dimensions } from "react-native";
import { useAppDispatch } from "src/redux";
import { tReduxAction } from "../types";
import { tRouteName, tSetBackButtonRoute } from "./types";

export const kWindowBreakpoints = {
  lg: 992,
  md: 768,
  sm: 576,
};

type tpAddPageListeners = (params: { window: { width: number; height: number } }) => tReduxAction;
export const addPageListeners: tpAddPageListeners =
  ({ window }) =>
  (dispatch, getState) => {
    const { drawerType, footerType, deviceSize } = getState().NavigationReducer;

    if (drawerType === "slide" && window.width > 1000)
      dispatch({ type: "UPDATE_DRAWER_TYPE", drawerType: "permanent" });
    if (drawerType === "permanent" && window.width < 1000)
      dispatch({ type: "UPDATE_DRAWER_TYPE", drawerType: "slide" });
    if ((footerType === "small" || footerType === undefined) && window.height > 1200)
      dispatch({ type: "UPDATE_FOOTER_TYPE", footerType: "big" });
    if ((footerType === "big" || footerType === undefined) && window.height < 1200)
      dispatch({ type: "UPDATE_FOOTER_TYPE", footerType: "small" });

    if ((deviceSize === "xs" || deviceSize === "sm" || deviceSize === "md") && window.width >= kWindowBreakpoints.lg)
      dispatch({ type: "UPDATE_DEVICE_SIZE", deviceSize: "lg" });
    else if (
      (deviceSize === "xs" || deviceSize === "sm" || deviceSize === "lg") &&
      window.width < kWindowBreakpoints.lg &&
      window.width >= kWindowBreakpoints.md
    )
      dispatch({ type: "UPDATE_DEVICE_SIZE", deviceSize: "md" });
    else if (
      (deviceSize === "xs" || deviceSize === "md" || deviceSize === "lg") &&
      window.width < kWindowBreakpoints.md &&
      window.width >= kWindowBreakpoints.sm
    )
      dispatch({ type: "UPDATE_DEVICE_SIZE", deviceSize: "sm" });
    else if (
      (deviceSize === "sm" || deviceSize === "md" || deviceSize === "lg") &&
      window.width < kWindowBreakpoints.sm
    )
      dispatch({ type: "UPDATE_DEVICE_SIZE", deviceSize: "xs" });

    // Dimensions.addEventListener("change", _onChange);
    // return () => {
    //   Dimensions.removeEventListener("change", _onChange);
    // };
  };

export const useResizeListener = (): void => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const listener = (params: { window: { width: number; height: number } }) => {
      dispatch(addPageListeners(params));
    };

    Dimensions.addEventListener("change", listener);
    return () => {
      Dimensions.removeEventListener("change", listener);
    };
  }, [dispatch]);
};

export const setBackButtonRoute = (backButtonRoute: tRouteName): tSetBackButtonRoute => {
  return {
    type: "SET_BACK_BUTTON_ROUTE",
    backButtonRoute,
  };
};
